/*
This file is automatically generated by the deploy.py script.
If you need to modify it, update the script and run with deploy turned off:

python3 deploy.py -x
*/

export default class CognitoConfig {
  static readonly clientId = '6f0a7qu53ble6olgb6hscp0m3d'
  static readonly userPoolId = 'us-gov-west-1_3UVPBe0bs'
  static readonly authUri = 'https://iscout.auth-fips.us-gov-west-1.amazoncognito.com'
  static readonly region = 'us-gov-west-1'
  static readonly scope = 'openid email'

  static get redirectUri() {
    switch (window.location.hostname) {
      case 'localhost':
      case '127.0.0.1':
      case '[::1]': {
        // on localhost, redirect back to localhost
        return 'http://localhost:3000'
      }
      default: {
        // otherwise, use the standard domain name for this env
        return 'https://iscout.ai'
      }
    }
  }
}
